import { observer } from 'mobx-react-lite'
import { Button, DropdownContent, Typography } from 'shared/ui'
import { makeTextFieldAutoFocus, TextField } from 'shared/ui/TextField'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import { InboxesDropdownContentItems } from 'widgets/SearchDropdown/ui/DropdownContent/InboxesDropdownContent/InboxesDropdownContentItems'
import { type SearchDropdownInboxesStore } from 'widgets/SearchDropdown/store/searchDropdownInboxesStore'
import styles from './styles.module.scss'

type IInboxesDropdownContentProps = {
  store: SearchDropdownInboxesStore
  onChange?: (item: Inbox) => void
  width?: number
}

export const InboxesDropdownContent = observer(
  ({ store, onChange, width }: IInboxesDropdownContentProps) => {
    const { search, init, maxLimit } = store

    const handleReset = () => {
      store.resetType()
      init()
    }

    return (
      <DropdownContent noPadding className={styles.wrap} width={width}>
        <div className={styles.searchWrap}>
          <TextField
            className={styles.search}
            variant='integrated'
            InputProps={{
              placeholder: 'Search inbox',
            }}
            onChange={store.handleSearch}
            value={search}
            mainActions={[makeTextFieldAutoFocus({ withFocus: !search })]}
          />
        </div>
        {maxLimit && (
          <Typography
            variant='body-sm-medium'
            color='var(--content-primary-tertiary)'
            ariaLabel='InboxesDropdownLimit'
            className={styles.limitInfo}
          >
            Select inboxes (up to {maxLimit})
          </Typography>
        )}

        <InboxesDropdownContentItems store={store} onChange={onChange} />

        {store.hasSelectedItems && (
          <div className={styles.clear}>
            <Button typeBtn={'text'} text={'Clear'} onClick={handleReset} />
          </div>
        )}
      </DropdownContent>
    )
  }
)
